document.addEventListener('DOMContentLoaded', function () {
  var toggleCm = document.getElementById('toggle-cm');
  var toggleInch = document.getElementById('toggle-inch');
  var values = document.querySelectorAll('.value');

  toggleCm.addEventListener('click', function () {
    toggleUnits('cm');
  });

  toggleInch.addEventListener('click', function () {
    toggleUnits('inch');
  });

  function toggleUnits(unit) {
    values.forEach(function (value) {
      var cmValue = parseFloat(value.getAttribute('data-cm'));
      if (unit === 'inch') {
        value.textContent = (cmValue / 2.54).toFixed(1); // Convert to inches and format to 1 decimal
        toggleCm.classList.remove('active');
        toggleInch.classList.add('active');
      } else {
        value.textContent = Math.round(cmValue); // Remove decimal points for cm
        toggleInch.classList.remove('active');
        toggleCm.classList.add('active');
      }
    });
  }
});
